<template>
  <thux-table :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll('id')"
    @check-none="checkNone('id')"
    @set-selected-row="setSelectedRow($event, 'id')"
    :show-checks="showChecks"
    :showDetailButton="showDetailButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-detail-form="$emit('open-detail-form', $event)">
    <template slot="sections" slot-scope="row">
        {{ (row.item.sections_names || []).join(', ') }}
    </template>
  </thux-table>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as USER_TYPES } from './store.js'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'accountTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'code',
          label: this.$t('Code'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'code'
        },
        {
          key: 'name',
          label: this.$t('Name'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'name'
        },
        {
          key: 'sections',
          label: this.$t('Sections'),
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: false,
          custom: true,
          value: 'sections'
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: ['code', 'name', 'sections'],
      fieldName: 'id'
    }
  },
  computed: {
    ...mapGetters({
      selectAll: USER_TYPES.GENERIC.account.teamrole.LIST.GETTERS.selectAll,
      selectedList: USER_TYPES.GENERIC.account.teamrole.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return false
    },
    showDetailButton () {
      return hasPerm('account_user_retrieve')
    }
  },
  methods: {
    ...mapMutations({
      setList: USER_TYPES.GENERIC.account.teamrole.LIST.MUTATIONS.setList,
      setSelectedList:
        USER_TYPES.GENERIC.account.teamrole.LIST.MUTATIONS.setSelectedList,
      setSelectAll: USER_TYPES.GENERIC.account.teamrole.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...USER_TYPES.GENERIC.account.teamrole.LIST.ACTIONS,
      _delete: USER_TYPES.GENERIC.account.teamrole.DETAIL.ACTIONS.delete
    })
  }
}
</script>
